export default {
  errors: {
    forbidden: 'No tienes acceso a este reporte. Si lo necesitas, pídele a tu administrador que te lo habilite.',
    failed: 'No se pudo generar el reporte. Intenta de nuevo en unos minutos.'
  },
  labels: {
    incidences_report: 'Reporte de Incidencias',
    pictures_report: 'Reporte de fotos',
    sprint_report: 'Reporte de Sprint',
    consolided_report: 'Reporte consolidado',
    location_report: 'Reporte de ruta',
    quantitative_report: 'Reporte cuantitativo',
    sales_report: 'Reporte de ventas',
    soriana_report: 'Reporte de Soriana',
    critical_points_report: 'Reporte de puntos críticos',
    general2_report: 'Reporte Praxair',
    cash_report: 'Reporte de arqueo',
    user_report: 'Reporte de usuario',
    self_evaluation_report: 'Reporte de Autoevaluación',
    user_action_plans_report: 'Reporte de planes de acción (Usuario)',
    semaphore_report: 'Reporte de semáforo',
    executive_report: 'Reporte ejecutivo',
    incidences_by_location: 'Reporte de Incidencias por Ubicación',
    extras: 'Reporte de Campos Extra',
    show_videos: 'Ver Videos',
    show_photos: 'Ver Fotos',
    play_video: 'Reproducir video'
  },
  general: 'Reporte General',
  incidences: 'Reporte de Incidencias',
  photos: 'Reporte de Fotos',
  quantitative: 'Reporte cuantitativo',
  consolided: 'Reporte Consolidado',
  agenda_report: 'Reporte de Agenda',
  user: 'Reporte de Usuarios',
  // Selector de usuarios en la configuración de reportes
  loading_users: 'Cargando Usuarios...',
  tasks: 'Reporte de Tareas',
  sprints: 'Reporte de Sprints',
  extras: 'Reporte de Campos Extras',
  campaigns: 'Reporte de Campañas',
  self_evaluation: 'Reporte de Autoevaluación',
  cash: 'Reporte de Arqueo',
  critical_points: 'Reporte de Puntos críticos',
  location: 'Reporte de Ruta',
  semaphore: 'Reporte de Semáforo',
  executive: 'Reporte Ejecutivo',
  incidences_by_location: 'Reporte de Incidencias (Ubicación)',
  general2: 'Reporte Praxair',
  category: 'Reporte de Resumen Integral',
  category_toks: 'Reporte de Resumen Integral Toks',
  workday: 'Reporte de Calidad',
  responsability_leadership: 'Reporte de Responsabilidades',
  calimax_workday: 'Reporte Calimax Auditoría Integral',
  board: 'Reporte de Tablero',
  answers: 'Reporte por Item',
  consolidated_answers: 'Reporte Consolidado del Item',
  follow_up: 'Reporte de Seguimiento',
  dimsa_rac: 'Reporte DIMSA RAC',
  form_by_scale: 'Reporte de Evaluación de Formulario',
  power_factor: 'Reporte de Factor de Potencia',
  fullfillment: 'Reporte de Cumplimiento',
  auditor_role: 'Reporte de Formularios por Auditor',
  resources: 'Reporte de Recursos',
  unified_incidences: 'Reporte de Incidencias Agrupadas',
  expiration: 'Reporte de Caducidad',
  caducity: 'Reporte de Consolidación',
  management_report: 'Reporte Administrativo',
  weighted_score: 'Reporte Ponderado',
  executive_report: {
    answers: 'Respuestas',
    comments: 'Comentarios',
    pictures: 'Imágenes',
    original: 'Orden original',
    first_critical_points: 'Primero puntos críticos',
    first_no_critical_points: 'Primero puntos no críticos'
  },
  non_executions_report: 'Reporte No Ejecuciones',
  tables_report: 'Reporte de Tablas',
  forensic_audit: 'Reporte de Auditoría Forense Innova',
  planogram_report: 'Reporte de Planogramas',
  planogram_quality_report: 'Reporte de Planogramas (Calidad)',
  planogram_table_report: 'Reporte de Planogramas (Tabla)',
  planogram_table: {
    area: 'Área',
    planogram: 'Planograma',
    auditor: 'Auditor',
    date: 'Fecha',
    score: 'Calificación',
    consolidated: 'Consolidado',
    legend_no: '0 = NO CUMPLE / NO SE APLICÓ / FALSO',
    legend_yes: '1 = SÍ CUMPLE / SÍ SE APLICÓ / VERDADERO',
    evaluations: 'evaluaciones',
    auditors: 'Auditores',
    manager_placeholder: '[Nombre gerente de tienda]',
    no_results: 'No hay evaluaciones de planogramas cerradas en el periodo seleccionado.',
    skipped_forms: 'Formularios sin estructura de planogramas (omitidos)'
  },
  daily: 'Reporte Diario',
  execution_time: 'Reporte de Tiempos de Ejecución',
  administration_report: 'Reporte de Administración',
  user_tracking_report: 'Reporte Seguimiento Usuario',
  satisfaction_surveys: 'Reporte de Voice Value',
  check_in: 'Reporte de Check-In',
  attendance: 'Reporte de Asistencia',
  attendance_report: {
    title: 'Reporte de Asistencia',
    user: 'Usuario',
    location: 'Ubicación',
    total_records: 'Usuarios',
    period_days: 'Días del periodo',
    download_excel: 'Descargar Excel',
    forms_used: 'Formularios utilizados',
    not_detected: 'no detectado',
    legend: 'Simbología',
    no_results: 'No hay asistencia para los filtros seleccionados.',
    workdays: 'Jornadas',
    lates: 'Retardos',
    omitted_entries: 'AO',
    absences: 'Faltas',
    rests: 'Descansos',
    sunday_premiums: 'Prima dominical',
    form_roles: {
      check_in: 'Check-in en tiempo',
      late_check_in: 'Check-in fuera de tiempo',
      lunch: 'Horario de comida',
      check_out: 'Check-out'
    },
    codes: {
      attendance: 'Asistencia',
      late: 'Retardo',
      omitted_entry: 'Asistencia con entrada omitida',
      absence: 'Falta',
      rest: 'Descanso',
      undetermined: 'Sin programación confiable'
    }
  },
  merma_harvest: 'Reporte de Merma / Harvest',
  exhibitions: 'Reporte de Exhibiciones',
  check_in_report: {
    title: 'Reporte de Check-In',
    user: 'Usuario',
    location: 'Ubicación',
    hierarchy: 'Zona / Jerarquía',
    date: 'Fecha',
    time: 'Hora Check-In',
    latitude: 'Latitud',
    longitude: 'Longitud',
    address: 'Dirección',
    perimeter: 'Perímetro',
    distance: 'Distancia (m)',
    inside: 'Dentro',
    outside: 'Fuera',
    not_applicable: 'N/A',
    no_results: 'No hay check-ins para los filtros seleccionados.',
    total_records: 'Total de registros'
  },
  // Metricas y stats del reporte de tareas
  select_locations: 'Ubicaciones seleccionadas',
  completed: 'Completadas',
  in_process: 'En proceso',
  expired: 'Vencidas',
  total: 'Total',
  last_trimester_tasks: 'Tareas del trimeste pasado',
  created: 'Creadas',
  created_at: 'Creadas',
  suspended: 'Suspendidas',
  location_tasks: 'Tareas por ubicación',
  time: 'En tiempo',
  in_progress: 'En proceso',
  out_of_time: 'Fuera de tiempo',
  in_progress_out_time: 'Vencidas',
  completed_on_time: 'Completadas en tiempo',
  completed_out_time: 'Completadas fuera de tiempo',
  // Estados de tarea usados en el dialogo de reporte
  report: {
    assigned: 'asignada',
    finished: 'finalizada',
    suspended: 'suspendida'
  },
  // Labels del dialogo de detalle de reporte de tarea
  dialog_report: {
    assigned_to: 'Asignada a',
    today: 'Hoy',
    days: 'dias',
    day: 'dia',
    category: 'Categoria'
  },
  // Texto de graficos del reporte de tareas por categoria/area
  graphOptions: {
    tasks_by_category: 'Tareas por categoría',
    tasks_by_area: 'Tareas por area'
  },
  // Columnas del dialogo de configuracion de la tabla de tareas, compartido con Torre de Control
  columnsDialog: {
    title: 'Titulo',
    created_by: 'Creado por',
    assigned_to: 'Asignado a',
    update_at: 'Ultima modificación',
    end_date: 'Fecha limite',
    category: 'Categoria',
    state: 'Estado'
  },
  // Columnas de titulo (usuario/ubicacion) del reporte de tareas
  titleColum: {
    user: 'Usuario',
    location: 'Ubicación'
  },
  download: {
    title: 'Tipo de descarga',
    browser: 'Descargar en Navegador',
    email_link: 'Link por Correo',
    email_send: 'Enviar por Correo',
    local: 'Descarga Local',
    started_email: 'La exportación ha comenzado. Recibirás un correo cuando esté lista.',
    started_notification: 'La exportación ha comenzado. Te avisaremos en el panel de notificaciones cuando esté lista.',
    error: 'No se pudo solicitar la exportación. Intenta de nuevo.'
  },
  pdf_export: {
    title: 'Reporte General en PDF',
    selection: 'Ubicaciones: {locations} · Formularios: {forms}',
    fallback: 'Este reporte es más grande de lo previsto, así que lo generaremos en segundo plano.',
    generating: 'Generando PDF…',
    ready: 'PDF listo, descargando…',
    closed_hint: 'Puedes cerrar esta ventana: te avisaremos en notificaciones cuando esté listo.',
    close: 'Cerrar',
    downloaded: 'PDF descargado',
    sent_to_notifications: 'Tu PDF ya está listo: te lo enviamos a tus notificaciones.',
    file_error: 'No se pudo descargar el PDF. Te avisaremos en notificaciones para que lo descargues desde ahí.',
    error_failed: 'No se pudo generar el PDF. Intenta de nuevo en unos minutos.',
    error_timeout: 'La generación del PDF tardó demasiado y se detuvo. Intenta con menos ubicaciones o formularios.',
    error_rate_limited: 'Ya tienes varias exportaciones en curso. Intenta de nuevo en {minutes} min.',
    error_unexpected: 'No se pudo generar el PDF. Intenta de nuevo.'
  }
}
